import React from 'react';
import { isMadPawsStore } from '../../../common/util';


const PrescriptionIcon = () => {
  return (
    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.966499 3.12597C0.966499 5.38877 0.467514 11.2517 1.26594 12.846C2.06438 14.4917 6.45539 17.1146 8.30164 18.3489C10.1479 17.1147 14.539 14.5431 15.3373 12.846C16.1358 11.2516 15.6866 5.38883 15.6866 3.12597C13.7904 2.30304 10.098 0.348877 8.3016 0.348877C6.55516 0.348877 2.86264 2.3032 0.966499 3.12597Z"
        fill={isMadPawsStore() ? 'var(--primary-default)' : '#1990BA'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16406 5.24507C6.16406 5.02628 6.33302 4.84888 6.54139 4.84888H8.06341C9.06568 4.84888 9.8782 5.70202 9.8782 6.7544C9.8782 7.80677 9.06568 8.65992 8.06341 8.65992H7.95409L11.8589 13.4393C11.9946 13.6054 11.9763 13.8555 11.8181 13.998C11.6599 14.1405 11.4217 14.1213 11.2861 13.9552L6.95983 8.66004H6.91873V11.2824C6.91873 11.5012 6.74986 11.6786 6.54141 11.6786C6.33304 11.6786 6.16408 11.5012 6.16408 11.2824L6.16406 5.24507ZM6.91871 7.86763V5.64135H8.06341C8.64894 5.64135 9.12355 6.13978 9.12355 6.75449C9.12355 7.36919 8.64894 7.86763 8.06341 7.86763H6.91871Z"
        fill={isMadPawsStore() ? 'var(--tertiary-default)' : 'white'}
        stroke={isMadPawsStore() ? 'var(--tertiary-default)' : 'white'}
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2061 8.55369C11.371 8.6874 11.4015 8.93625 11.2742 9.10942L7.72285 13.9391C7.59551 14.1123 7.35858 14.1444 7.19368 14.0107C7.02868 13.8769 6.99819 13.6281 7.12554 13.4549L10.6769 8.62501C10.8042 8.45185 11.0412 8.41984 11.2061 8.55355V8.55369Z"
        fill={isMadPawsStore() ? 'var(--tertiary-default)' : 'white'}
        stroke={isMadPawsStore() ? 'var(--tertiary-default)' : 'white'}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default PrescriptionIcon;
